import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'umi';
import { useNewSelectorParams } from '@/pages/dashboard/utils/useNewSelectorParams';
import { FilterItemType } from '@/pages/dashboard/types/dashboard';

export const useFilterData = (path:string,pageDefaultSelector: FilterItemType[]) => {
  const dispatch = useDispatch();
  const { currentGame} = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame,
    };
  });
  const  {loading, getSelectorList} = useNewSelectorParams({
    realPath: path,
    pageDefaultSelector,
    isUseFrontFilterConfig: false
  });

  const selectorRef = useRef<any>();

  // 初始化
  useEffect(() => {
    const gameCode = currentGame?.game_code;
    getSelectorList().then((data)=>{
      selectorRef.current = { ...(data || {}), gameCode };
      dispatch({
        type: 'dashboardSetting/save',
        payload: {
          selector: selectorRef.current,
        },
      });
    }).catch((e)=>{
      console.log(e);
    });
  }, [currentGame]);

  return {
    loading,
    selector: selectorRef?.current
  };
};